import { Button } from "reactstrap";
import CustomSpinner from "./CustomSpinner";
import { CustomButtonProps } from "../../Type";

const CustomButton = ({
  label,
  isLoading,
  className,
  color,
  handleSubmit,
  onClick,
  disabled,
  type = "submit",
}: CustomButtonProps) => {
  return (
    <Button
      type={type}
      className={className}
      color={color}
      disabled={isLoading || disabled} 
      onClick={onClick || handleSubmit}
    >
      {isLoading ? <CustomSpinner /> : label}
    </Button>
  );
};

export default CustomButton;
